module.exports = __webpack_public_path__ + "img/shequyanglao.573f44b7.png";